<template>
  <div class="c-app">
    <TheSidebar/>
    <TheAnotherSidebar/>

    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main" style="padding: 3px">
          <CContainer fluid>
            <Modals ref="modal2"/>
            <AddBaseDataModal />
            <Loading ref="loading_component"/>
            <CButton v-if="false" v-on:click="topFunction()" style="margin-bottom: 30px" id="myBtn"
                     title="Go to top">
              <CIcon style="width: 35px;height: 35px" class="text-dark" name="cilChevronCircleUpAlt"/>
            </CButton>

            <transition name="fade">
              <router-view></router-view>
            </transition>

          </CContainer>
        </main>
      </div>
      <TheFooter/>

    </CWrapper>
    <cookie-law theme="dark-lime"></cookie-law>


  </div>
</template>

<script>
import CookieLaw from 'vue-cookie-law'

import TheSidebar from './TheSidebar'
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import TheAnotherSidebar from './TheAnotherSidebar'
import Modals from "../views/panel/includes/Modals";
import Loading from "../views/panel/includes/LoadingPage";
import AddBaseDataModal from "../views/panel/includes/AddBaseDataModal";
import axios from "axios";

import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
export default {
  name: 'TheContainer',
  props: {},
  data() {
    return {
      theme_mode_parent: '',
      mybutton: '',
    }
  }, components: {
    CookieLaw,
    Modals,
    Loading,
    TheSidebar,
    TheAnotherSidebar,
    TheHeader,
    TheFooter,
    AddBaseDataModal,
  }, beforeCreate() {
    // this.fetch_config()
  }
  , methods: {
    topFunction() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    },

    scrollFunction() {
      // if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      //   this.mybutton.style.display = "block";
      // } else {
      //   this.mybutton.style.display = "none";
      // }
    },

  },
  mounted() {
    this.$root.modal_component = this.$refs.modal2;
    this.$root.loading_component = this.$refs.loading_component;
console.log("locale is ",this.$i18n.locale)

    this.mybutton = document.getElementById("myBtn");
    var self = this;
// When the user scrolls down 20px from the top of the document, show the button
    window.onscroll = function () {
      self.scrollFunction()
    };

  },

}
</script>


<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#myBtn {
  display: none; /* Hidden by default */
  position: fixed; /* Fixed/sticky position */
  bottom: 20px; /* Place the button at the bottom of the page */
  left: 30px; /* Place the button 30px from the right */
  z-index: 99; /* Make sure it does not overlap */
  border-color: red;
  outline: none; /* Remove outline */
  background-color: white; /* Set a background color */
  color: white; /* Text color */
  cursor: pointer; /* Add a mouse pointer on hover */
  padding: 10px; /* Some padding */
  border-radius: 10px; /* Rounded corners */
  font-size: 18px; /* Increase font size */
}

#myBtn:hover {
  background-color: #555555; /* Add a dark-grey background on hover */
}
</style>
